const getters = {
  // app.ts 中的getters
  collapse: (state: TypeObject): boolean => state.app.collapse,
  device: (state: TypeObject): boolean => state.app.device,
  loading: (state: TypeObject): boolean => state.app.loading,
  logoType: (state: TypeObject): string => state.app.logoType,
  currentDate: (state: TypeObject): boolean => state.app.currentDate,

  layout: (state: TypeObject): string => state.app.layout,
  useBreadcrumb: (state: TypeObject): boolean => state.app.useBreadcrumb,
  useMultipleNav: (state: TypeObject): boolean => state.app.useMultipleNav,
  useKeepAlive: (state: TypeObject): boolean => state.app.useKeepAlive,
  navbarBackground: (state: TypeObject): boolean => state.app.navbarBackground,
  sidebarBackground: (state: TypeObject): boolean => state.app.sidebarBackground,
  useHeader: (state: TypeObject): boolean => state.app.useHeader,
  useSidebar: (state: TypeObject): boolean => state.app.useSidebar,

  // dataInit.ts 中的getters,多导航标签用
  dataInitMap: (state: TypeObject): TypeObject => state.dataInit.dataInitMap,

  // multipleNav
  visitedViews: (state: TypeObject): TypeObject[] => state.multipleNav.visitedViews,
  cachedViews: (state: TypeObject): string[] => state.multipleNav.cachedViews,

  // user.ts 中的getters
  // menus: (state: TypeObject): any => state.user.menus,
  // menuAuthKeys: (state: TypeObject): any => state.user.menuAuthKeys,
  // userInfo: (state: TypeObject): any => state.user.userInfo,

  // permission.ts 中的getters
  // permissionRoutes: (state: TypeObject): any => state.permission.permissionRoutes,
};
export default getters;
